(function () {
            // Observe all major page/panel containers
            const observerOptions = {
                root: null,
                rootMargin: '0px',
                threshold: 0.0
            };

            const pauserObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    // If it is completely out of view, pause it
                    if (!entry.isIntersecting) {
                        // Small delay to allow transition animations (e.g. GSAP) to finish before pausing
                        setTimeout(() => {
                            // Double check it's still not intersecting
                            const rect = entry.target.getBoundingClientRect();
                            if (rect.width === 0 || rect.height === 0 || rect.top >= window.innerHeight || rect.bottom <= 0 || rect.left >= window.innerWidth || rect.right <= 0 || window.getComputedStyle(entry.target).opacity == 0) {
                                if (!entry.target.classList.contains('paused-rendering')) {
                                    entry.target.classList.add('paused-rendering');
                                }
                            }
                        }, 600); // 600ms covers the standard 0.5s GSAP durations used in the app
                    } else {
                        if (entry.target.classList.contains('paused-rendering')) {
                            entry.target.classList.remove('paused-rendering');
                        }
                    }
                });
            }, observerOptions);

            function observePages() {
                // Find all potential page panels/sections
                const panels = document.querySelectorAll('.login_box, .page, .panel, .screen, .view, .view-layer, .section');
                panels.forEach(p => {
                    // Ignore small inline elements if they accidentally matched
                    if (p.tagName !== 'SPAN' && p.tagName !== 'A' && p.tagName !== 'BUTTON') {
                        pauserObserver.observe(p);
                    }
                });

                // Also monitor DOM mutations to observe newly created dynamic panels
                const mutationObserver = new MutationObserver((mutations) => {
                    mutations.forEach(m => {
                        if (m.type === 'childList') {
                            m.addedNodes.forEach(node => {
                                if (node.nodeType === 1) { // Element node
                                    if (node.matches && node.matches('.login_box, .page, .panel, .screen, .view, .view-layer, .section')) {
                                        pauserObserver.observe(node);
                                    }
                                }
                            });
                        }

                        // Also check for class changes like adding/removing .active
                        if (m.type === 'attributes' && m.attributeName === 'class') {
                            const target = m.target;
                            if (target.matches && target.matches('.login_box, .page, .panel, .screen, .view, .view-layer, .section')) {
                                if (!target.classList.contains('active') && window.getComputedStyle(target).opacity == 0) {
                                    if (!target.classList.contains('paused-rendering')) {
                                        target.classList.add('paused-rendering');
                                    }
                                } else if (target.classList.contains('active')) {
                                    if (target.classList.contains('paused-rendering')) {
                                        target.classList.remove('paused-rendering');
                                    }
                                }
                            }
                        }
                    });
                });

                mutationObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
            }

            // Start observing when DOM is ready
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', observePages);
            } else {
                observePages();
            }
        })();